import { useState, KeyboardEvent, MouseEvent } from "react"
import { useNavigate } from "react-router-dom"
import { Box, ThemeProvider, Typography } from "@mui/material"

import { MetricHeaderWrapper } from "../Atom"
import {
  AssignButton,
  customTheme,
  MetricGoalsHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
} from "./Atom"

import { MetricBlueprintAssignDrawer } from "../../Drawer"
import { HeaderInfoNav } from "../Reusable"
import { useDispatch } from "react-redux"
import {
  setSelectedBlueprintMetrics,
  setSelectedBlueprintMetricsEmpty,
} from "../../../redux/slices/metricSlice"
import { colors } from "../../../../styles/commonStyles"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"

export type Anchor = "top" | "left" | "bottom" | "right"

export default function MetricBlueprintHeader(props: any) {
  const { name, fetchAllGroups, assignMetricsToGroups } = props

  const [state, setState] = useState({
    right: false,
  })

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: KeyboardEvent | MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as KeyboardEvent).key === "Tab" ||
          (event as KeyboardEvent).key === "Shift")
      ) {
        return
      }

      setState({ ...state, [anchor]: open })
    }

  function closeSidebar() {
    setState({ right: false })
  }

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <MetricHeaderWrapper>
          <MetricHeaderLeft>
            <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
          </MetricHeaderLeft>

          <MetricGoalsHeaderMid sx={{ flex: 1 }}></MetricGoalsHeaderMid>

          <MetricHeaderRight>
            <PermsWrapper perm={permissions?.BLUEPRINT_ASSIGN_REMOVE_METRIC}>
              <AssignButton
                onClick={toggleDrawer("right", true)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: colors.primaryOrange,
                  "&:hover": {
                    backgroundColor: colors.primaryOrange,
                  },
                }}
              >
                <Typography>Assign</Typography>
              </AssignButton>
            </PermsWrapper>
          </MetricHeaderRight>
        </MetricHeaderWrapper>

        <MetricBlueprintAssignDrawer
          state={state}
          toggleDrawer={toggleDrawer}
          closeSidebar={closeSidebar}
          fetchAllGroups={fetchAllGroups}
          assignMetricsToGroups={assignMetricsToGroups}
        />
      </ThemeProvider>
    </>
  )
}
